import { apiGet } from './client.js';
import type { KeywordTrendResponse, ReportFilters, ReportResponse } from '../types/report.js';

const DEFAULT_GROUP_BY: Array<keyof ReportResponse['data'][number]['group']> = [
  'appleAdsType',
  'campaignName',
  'adGroupName',
  'keywordName',
];

const serializeGroupBy = (groupBy?: Array<keyof ReportResponse['data'][number]['group']>) =>
  groupBy && groupBy.length > 0 ? groupBy.join(',') : undefined;

export const fetchReport = async (
  filters: ReportFilters,
  options?: { signal?: AbortSignal }
): Promise<ReportResponse> => {
  const params = new URLSearchParams();
  params.set('metric', filters.metric);
  params.set('from', filters.from);
  params.set('to', filters.to);
  params.set('sortBy', filters.sortBy);
  params.set('sortOrder', filters.sortOrder);

  const groupBy = filters.groupBy ?? DEFAULT_GROUP_BY;
  const serialized = serializeGroupBy(groupBy);
  if (serialized) {
    params.set('groupBy', serialized);
  }

  const query = `/reports?${params.toString()}`;

  return apiGet<ReportResponse>(query, options);
};

export const defaultGroupBy = DEFAULT_GROUP_BY;

export const fetchKeywordTrend = async (
  target: {
    campaignName: string;
    campaignId: string | null;
    adGroupName: string | null;
    adGroupId: string | null;
    keywordName: string;
    keywordId: string | null;
    orgId: string | null;
  },
  weeks: number,
  options?: { signal?: AbortSignal }
): Promise<KeywordTrendResponse> => {
  const params = new URLSearchParams();
  params.set('campaignName', target.campaignName);
  if (target.campaignId) {
    params.set('campaignId', target.campaignId);
  }
  if (target.adGroupName) {
    params.set('adGroupName', target.adGroupName);
  }
  if (target.adGroupId) {
    params.set('adGroupId', target.adGroupId);
  }
  params.set('keywordName', target.keywordName);
  if (target.keywordId) {
    params.set('keywordId', target.keywordId);
  }
  if (target.orgId) {
    params.set('orgId', target.orgId);
  }
  params.set('weeks', String(weeks));

  return apiGet<KeywordTrendResponse>(`/reports/keyword-detail?${params.toString()}`, options);
};
